module.exports = __webpack_public_path__ + "img/img0.5a6499ac.jpg";